import { call, cancelled, put } from 'redux-saga/effects';
import { api } from '../../configurations/api';
import { dashboardUrl } from '../../configurations/api/url';
import { SentryCapture } from '../../analytics/Sentry';
import { globalErrorHandler } from '../error/saga';
import { httpRequest } from '../types';
import { getUsersDashboardFail, getUsersDashboardSuccess } from './actions';
import { IUsersDashboard, IUsersDashboardData } from './types';

export function* getUsersDashboardSaga({
    payload,
    resolve,
    reject,
}: {
    payload: IUsersDashboard;
    resolve: (data: IUsersDashboardData) => void;
    reject: (error: any) => void;
}): any {
    const queryParams = new URLSearchParams();
    if (payload.limit) queryParams.append('limit', String(payload.limit));
    if (payload.page) queryParams.append('page', String(payload.page));
    if (payload.category) queryParams.append('category', payload.category);
    if (payload.searchTerm) queryParams.append('searchTerm', payload.searchTerm);
    if (payload.sortBy) queryParams.append('sortBy', payload.sortBy);
    if (payload.sort !== undefined) queryParams.append('sort', String(payload.sort));

    const request = `${dashboardUrl}?${queryParams.toString()}`;

    let settled = false;

    try {
        const response = yield call(api, request, httpRequest.GET, null, 0, 0);
        const { data }: { data: IUsersDashboardData } = response;
        yield put(getUsersDashboardSuccess({ ...data }));
        if (resolve) {
            settled = true;
            resolve(data);
        }
    } catch (error: any) {
        SentryCapture(error, 'error');
        yield put(getUsersDashboardFail(error));
        yield call(globalErrorHandler, error);
        if (reject) {
            settled = true;
            reject(error);
        }
    } finally {
        // A superseded request must still settle, otherwise callers awaiting it stay loading forever.
        if ((yield cancelled()) && !settled && reject) {
            reject(new Error('Dashboard fetch cancelled'));
        }
    }
}
